import crypto from "crypto";

const IV_LENGTH = 16;

export const getKey = (secret: string): Buffer => {
	return crypto.createHash("sha256").update(secret).digest();
};
export function encryptAES256(data: any, secretKey: Buffer): string {
	const iv = crypto.randomBytes(IV_LENGTH);
	const cipher = crypto.createCipheriv("aes-256-cbc", secretKey, iv);
	let encrypted = cipher.update(JSON.stringify(data), "utf8", "base64");
	encrypted += cipher.final("base64");
	return iv.toString("base64") + ":" + encrypted;
}

export function decryptAES256(encrypted: string, secretKey: Buffer): any {
	const [ivBase64, encryptedData] = encrypted.split(":");
	const iv = Buffer.from(ivBase64, "base64");
	const decipher = crypto.createDecipheriv("aes-256-cbc", secretKey, iv);
	let decrypted = decipher.update(encryptedData, "base64", "utf8");
	decrypted += decipher.final("utf8");
	return JSON.parse(decrypted);
}
